import { createFileRoute } from '@tanstack/react-router'
import { nodeCanvas } from '@/lib/queries/node-canvases'
import { NodesListPage } from '@/features/workspaces/nodes'

function NodesRouteComponent() {
  const { orgId, workspaceId } = Route.useParams()
  return <NodesListPage orgId={orgId} workspaceId={workspaceId} />
}

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/workspace/$workspaceId/nodes/'
)({
  loader: async ({ context, params }) => {
    await context.queryClient.query(
      nodeCanvas.findManyByWorkspace(params.workspaceId)
    )
  },
  component: NodesRouteComponent,
})
